import { Outlet } from 'react-router-dom'

import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import { styled, useTheme } from '@mui/material/styles'
import { useNewOrderNotifications } from 'hooks/useNewOrderNotifications'
import { colors, settings } from 'ThemeStyle'

import Header from './Header/'
import Sidebar from './Sidebar/'
import InstallPwaGuideHost from 'components/pwa/InstallPwaGuideHost'
import ManagerRouteGuard from 'components/auth/ManagerRouteGuard'

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
  overflowX: 'hidden',
})

const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })(
  ({ theme }: { theme: any }) => ({
    flexGrow: 1,
    width: '100%',
    minWidth: 0,
    height: `calc(99vh - ${theme.mixins.toolbar.minHeight}px)`,
    overflow: 'hidden',
    marginTop: theme.mixins.toolbar.minHeight + 10,
    backgroundColor: '#fff',
    background: colors.background,
    zIndex: 2,
    borderTopLeftRadius: settings.blockBorderRadius,
    [theme.breakpoints.down('lg')]: {
      borderTopLeftRadius: 0,
      marginTop: theme.mixins.toolbar.minHeight,
      height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
    },
    [theme.breakpoints.up('lg')]: {
      borderTopLeftRadius: settings.blockBorderRadius,
      marginTop: theme.mixins.toolbar.minHeight + 10,
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      width: '100%',
      height: '100%',
      boxShadow: '3px 3px 10px -2px rgba(34, 60, 80, 0.2) inset',
      borderTopLeftRadius: settings.blockBorderRadius,
      pointerEvents: 'none',
      [theme.breakpoints.down('lg')]: {
        borderTopLeftRadius: 0,
        boxShadow: 'none',
      },
    },
  })
)

const ScrollWrapper = styled('main', { shouldForwardProp: prop => prop !== 'open' })(
  ({ theme }: { theme: any }) => ({
    height: `100%`,
    overflowY: 'auto',
    overflowX: 'hidden',
    zIndex: 1,
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    WebkitOverflowScrolling: 'touch',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(3),
    },
  })
)

/**
 * Основной layout админки с адаптацией под мобильные экраны.
 */
const MainLayout = () => {
  const theme = useTheme()
  // Уведомления о новых заказах на всех экранах авторизованной админки
  useNewOrderNotifications()

  return (
    <RootStyle>
      <CssBaseline />
      <Header />
      <Sidebar />
      <Main theme={theme}>
        <ScrollWrapper theme={theme}>
          <Container
            maxWidth={false}
            disableGutters
            sx={{
              px: { xs: 0, sm: 1 },
              maxWidth: '100%',
            }}
          >
            <InstallPwaGuideHost />
            <ManagerRouteGuard />
            <Outlet />
          </Container>
        </ScrollWrapper>
      </Main>
    </RootStyle>
  )
}

export default MainLayout
